(function () {
  'use strict';

  if (window.picturelineFooterPhoneLoaded) return;
  window.picturelineFooterPhoneLoaded = true;

  function updatePhone() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.getRegion !== 'function') return false;

    var region;
    try {
      region = privacy.getRegion();
    } catch (error) {
      return false;
    }

    // Shopify returns ISO country + subdivision, e.g. USUT for Utah.
    // Unknown locations retain the toll-free number rendered by Liquid.
    var isUtah = typeof region === 'string' && region.toUpperCase() === 'USUT';
    document.querySelectorAll('[data-footer-phone]').forEach(function (link) {
      link.href = isUtah ? 'tel:+18013641200' : 'tel:+18007488200';
      var label = link.querySelector('[data-footer-phone-label]');
      if (label) label.textContent = isUtah ? '801-364-1200' : '1-800-748-8200';
    });
    return true;
  }

  function initialize() {
    if (!document.querySelector('[data-footer-phone]') || updatePhone()) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) updatePhone();
      });
    } catch (error) {
      // Keep the working toll-free link when Shopify's API is unavailable.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  window.addEventListener('load', initialize, { once: true });
  document.addEventListener('shopify:section:load', initialize);
})();
